import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UpdateattachmentForm from "./UpdateattachmentForm";

interface ModalProps {
  attachment_id: number;
  category_id: number;
  file_name: string;
  modal: boolean;
  toggle?: () => void;
}

const UpdateAttachmentModal: React.FC<ModalProps> = ({
  attachment_id,
  category_id,
  file_name,
  toggle,
  modal,
}) => {

  return (
    <>
      <Modal size="lg" isOpen={modal} toggle={toggle} backdrop="static" keyboard={false}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Attachment</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">Update Attachment Category </P>
          </ModalHeader>
          <UpdateattachmentForm attachment_id={attachment_id} category_id={category_id} file_name={file_name} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UpdateAttachmentModal;
